/* global Marionette */
/* global brautbluete_form */
import ShowMore from './read_more';
import rest from '../utils/WordPressAPI';
import SweetScroll from 'sweet-scroll';
import inView from 'in-view';
const moment = require('moment');
const smScroll = new SweetScroll({
    header: '[data-uils="header"]',
    offset: -150
});

/**
 * KEYS - Constants representing keys used in the application.
 *
 * @type {Object}
 * @property {string} STORE - The key for store.
 * @property {string} TYPE - The key for type.
 * @property {string} APPOINTMENT_DATE - The key for appointment date.
 * @property {string} TIME - The key for time.
 */
const KEYS = {
    STORE: 'store',
    TYPE: 'type',
    APPOINTMENT_DATE: 'appointment_date',
    TIME: 'time',
    PERSONS: 'persons',
    ADDONS: 'addons',
    TOPIC: 'topic',
    WAITLIST_FROM: 'waitlist_from',
    WAITLIST_UNTIL: 'waitlist_until',

    CL_CLOTHING_SIZE: 'cl_clothing_size',
    CLOTHING_SIZE: 'clothing_size',

    CL_RING_FIELDS: 'cl_ring_fields',
    RING_TYPE: 'ring_type',
    RING_COLOR: 'ring_color',

    CL_ADDONS: 'cl_addons',

    CL_WEDDING_DAY: 'cl_wedding_day',
    WEDDING_DAY: 'event_date',

    CL_BUDGET: 'cl_budget',
    BUDGET: 'max_budget',

    CL_CONTACT_DATA: 'cl_contact_data',

    CL_STYLE: 'cl_style',
    STYLE: 'style',

    CL_FIRST_APPOINTMENT: 'cl_first_appointment',
    FIRST_APPOINTMENT: 'first_appointment',

    CL_REFERRAL: 'cl_referral',
    REFERRAL: 'referral',

    CL_DATE: 'cl_date',
};

/**
 * Hides the given field and optionally empties its value.
 *
 * @param {Object} field - The field to hide.
 * @param {Object} formModel - The form model that contains the field.
 * @param {Boolean} [empty=false] - Whether to empty the value of the field.
 *
 * @returns {void}
 */
const hideField = (field,formModel,empty = false) => {
    if(empty) {
        field.set( 'value', '' );
    }

    field.set('visible', false);
    field.trigger('change:value', field);

    if(formModel) {
        reRenderForm(formModel);
    }
};

/**
 * Shows a field and triggers necessary events and re-renders the corresponding form.
 *
 * @param {Field} field - The field to be shown.
 * @param {FormModel} formModel - The form model corresponding to the field.
 */
const showField = (field,formModel) => {
    field.set('visible', true);
    field.trigger('change:value', field);
    field.trigger('reRender');

    if(formModel) {
        reRenderForm(formModel);
    }
};

/**
 * updates a field and triggers necessary events and re-renders the corresponding form.
 *
 * @param {Field} field - The field to be shown.
 * @param {FormModel} formModel - The form model corresponding to the field.
 */
const updateField = (field,value,formModel) => {
    field.set( 'value', value );
    field.trigger('change:value', field);
    field.trigger('reRender');

    if(formModel) {
        reRenderForm(formModel);
    }
};


/**
 * Triggers the re-rendering of a form.
 *
 * @param {Object} formModel - The form model object.
 */
const reRenderForm = (formModel) => {
    formModel.trigger('reRender');
};

const daysToGivenDate = (targetDate) => {
    const [day, month, year] = targetDate.split('.').map(Number);
    const parsedTargetDate = new Date(year, month - 1, day);
    const currentDate = new Date();
    const timeDifference = parsedTargetDate - currentDate;
    return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
}

/**
 * Gets the details of a specific type based on store and number of persons.
 *
 * @param {number} type - The type to search for.
 * @param {string} store - The store to compare with.
 * @param {number} persons - The number of persons to compare with.
 * @returns {Object|boolean} - The type details if found, false otherwise.
 */
const getTypeDetails = (type,store,persons) => {

    const { types } = window.brautbluete_form.bridallive;
    let value = false;
    types.forEach((item,index) => {
        if(parseFloat(item.type) === type && store === item.store && !value) {
            if(parseInt(persons) <= parseInt(item.persons)) {
                value = types[index];
            }
        }
    });

    return value;

};

/**
 * Creates a value object for a given type.
 * @param {object} item - The type item.
 * @param {string} modelValue - The model value.
 * @param {string} personValue - The person value.
 * @returns {object} - The value object.
 */
const createTypeValueObject = (item, modelValue, personValue) => {
    const details = getTypeDetails(item.id, modelValue, personValue);
    if(details) {
        return {
            label: item.description,
            details: details,
            selected: false,
            value: item.id
        };
    }
};

window.addEventListener('DOMContentLoaded', () => {

    /**
     * A handler for the appointment form.
     * @constructor
     */
    const appointmentFormHandler = Marionette.Object.extend({

        initialize: function () {
            this.listenTo( Backbone.Radio.channel( 'flatpickr' ), 'init', this.appointmentDatepicker );
            this.listenTo(nfRadio.channel('form'), 'after:loaded', this.appointmentSetup );

            this.listenTo( Backbone.Radio.channel('fields'), 'change:model', this.conditionalLogic );

            this.debounceTimer = null;
            this.debounceDelay = 1000; // 1 second delay for scrolling
            this.blurTimer = null;
            this.blurDelay = 500; // 1.5 seconds delay for auto blur

            // Bind the focus and input event listeners
            this.bindFocusEvents();

        },

        bindFocusEvents: function() {
            document.addEventListener('focus', this.handleFocus.bind(this), true);
            document.addEventListener('input', this.handleInput.bind(this), true);
        },

        handleFocus: function(event) {
            if (event.target.classList.contains('nf-element')) {
                this.startBlurTimer(event.target);
            }
        },

        handleInput: function(event) {
            if (event.target.classList.contains('nf-element')) {
                this.resetBlurTimer(event.target);
            }
        },

        startBlurTimer: function(element) {
            this.clearBlurTimer();
            if(element.nodeName.toLowerCase() === 'input') {
                let inputType = element.type.toLowerCase();

                // Allow only specific input types
                const allowedTypes = ['email', 'tel', 'text', 'number'];
                if (!allowedTypes.includes(inputType)) {
                    return
                }

                if(element.classList.contains('datepicker')) {
                    return;
                }

                this.blurTimer = setTimeout(() => {
                    const fieldId = element.id.replace('nf-field-', '');
                    const fieldModel = nfRadio.channel('fields').request('get:field', fieldId);

                    if (fieldModel) {
                        try {
                            // Trigger change:value events

                            fieldModel.set( 'value', element.value );
                            fieldModel.trigger('change:value', fieldModel);

                        } catch (error) {
                            console.error('Error triggering change:model events:', error);
                        }
                    } else {
                        console.warn('Field model not found for element:', element);
                    }
                }, this.blurDelay);
            }
        },

        resetBlurTimer: function(element) {
            this.clearBlurTimer();
            this.startBlurTimer(element);
        },

        clearBlurTimer: function() {
            if (this.blurTimer) {
                clearTimeout(this.blurTimer);
            }
        },

        conditionalLogic: function( fieldModel ) {

            const fieldKey = fieldModel.attributes.key;

            if (fieldModel.changed.isUpdated === true && !fieldModel.attributes.invalid) {
                // Clear any existing scroll timer
                if (this.debounceTimer) {
                    clearTimeout(this.debounceTimer);
                }


                const scrollToElement = () => {
                    const ID_FORMAT = `nf-field-${fieldModel.attributes.id}-container`;
                    const fieldElement = document.getElementById(ID_FORMAT);

                    if (!fieldElement) {
                        console.log('fieldElement not found');
                        return;
                    }

                    const closestElement = fieldElement.closest('.nf-row');

                    if (!closestElement || !closestElement.nextElementSibling) {
                        console.log('Closest Element or the next sibling not found.');
                        return;
                    }

                    const nextElement = closestElement.nextElementSibling;

                    if (!inView.is(nextElement)) {
                        smScroll.toElement(nextElement);
                    }
                };
                scrollToElement();
            }

            // gather all form fields

            const fields = fieldModel.collection.models;

            if(fieldKey === KEYS.STORE || fieldKey === KEYS.PERSONS || KEYS.TYPE || KEYS.ADDONS || KEYS.TOPIC || KEYS.APPOINTMENT_DATE || KEYS.TIME || KEYS.WAITLIST_FROM || KEYS.WAITLIST_UNTIL) {

                // filter available types based on store and amount of persons

                const storeModel = findObjectModel(fields,KEYS.STORE);
                const personModel = findObjectModel(fields,KEYS.PERSONS);
                const topicModel = findObjectModel(fields,KEYS.TOPIC);
                const dateModel = findObjectModel(fields,KEYS.APPOINTMENT_DATE);
                const timeModel = findObjectModel(fields,KEYS.TIME);

                const typeModel = findObjectModel(fields,KEYS.TYPE);
                if(typeModel && 'attributes' in typeModel) {

                    const typeElm = document.getElementById(`nf-field-${typeModel.attributes.id}-container`);

                    if(fieldKey === KEYS.TYPE) {
                        setTimeout(() => {
                            new ShowMore('[data-read-more-container]:not([aria-expanded])', {
                                onMoreLess: (type, object) => {
                                },
                            });
                        },50);
                    }

                    if(typeElm && storeModel && topicModel && personModel) {
                        // get type dom element

                        // get all type list element options
                        const typeOptions = typeElm.querySelectorAll('.listimage__li');

                        // get filterable values

                        const personValue = parseInt(personModel.attributes.value);
                        const storeValue = storeModel.attributes.value;
                        const topicValue = topicModel.attributes.value;

                        // loop all options and toggle their visbility based on store and amount of persons

                        let minHeightValue = 0;
                        let hasValues = false;
                        typeOptions.forEach(typeOption => {
                            const label = typeOption.querySelector('label');
                            const button = typeOption.querySelector('.c-listimage-card__content-button');
                            const minHeight = typeOption.querySelector('.c-listimage-card__content-pricing');

                            if(typeOption.getAttribute('data-topic').includes(topicValue) && typeOption.getAttribute('data-store') === storeValue && personValue <= parseInt(typeOption.getAttribute('data-persons')) && personValue >= parseInt(typeOption.getAttribute('data-min-persons'))) {
                                typeOption.style.display = '';
                                hasValues = true;
                                const currentHeight = minHeight.offsetHeight;
                                if(minHeightValue < currentHeight) {
                                    minHeightValue = currentHeight;
                                }
                            } else {
                                typeOption.style.display = 'none';
                                const input = typeOption.querySelector('input');
                                if(input.classList.contains('nf-checked')) {
                                    typeModel.set( 'value', '' );
                                    typeModel.trigger( 'reRender', typeModel );
                                }
                            }

                            label.onclick = (e) => {
                                if(!e.srcElement.classList.contains('c-listimage-card__content-button') && !label.classList.contains('is-triggerd-by-event')) {
                                    e.preventDefault();
                                }
                            }

                            button.onclick = (e) => {
                                label.classList.add('is-triggerd-by-event');
                                label.click();
                                label.classList.remove('is-triggerd-by-event');
                            };

                        });

                        if(!hasValues) {
                            typeElm.style.display = 'none';
                        } else {
                            typeElm.style.display = '';
                        }

                        typeElm.style.setProperty('--pricing-height', `${minHeightValue}px`);
                    }
                }

                const addonsModel = findObjectModel(fields,KEYS.ADDONS);
                if(addonsModel && 'attributes' in addonsModel) {

                    const addonsElm = document.getElementById(`nf-field-${addonsModel.attributes.id}-container`);


                    if(fieldKey === KEYS.ADDONS) {
                        setTimeout(() => {
                            new ShowMore('[data-read-more-container]:not([aria-expanded])', {
                                onMoreLess: (type, object) => {
                                },
                            });
                        },500);
                    }

                    if(addonsElm && typeModel && personModel) {
                        // get type dom element

                        // get all type list element options
                        const addonsOptions = addonsElm.querySelectorAll('.listimage__li');

                        // get filterable values

                        const personValue = parseInt(personModel.attributes.value);
                        const typeValue = typeModel.attributes.value;
                        const topicValue = topicModel.attributes.value;
                        const dateValue = dateModel.attributes.value;

                        // loop all options and toggle their visbility based on store and amount of persons

                        let minHeightValue = 0;
                        let hasValues = false;

                        addonsOptions.forEach(addonsOption => {
                            const label = addonsOption.querySelector('label');
                            const button = addonsOption.querySelector('.c-listimage-card__content-button');
                            const minHeight = addonsOption.querySelector('.c-listimage-card__content-pricing');

                            if(addonsOption.getAttribute('data-topic').includes(topicValue) && addonsOption.getAttribute('data-type').indexOf(typeValue) !== -1) {
                                if(personValue <= parseInt(addonsOption.getAttribute('data-persons')) && personValue >= parseInt(addonsOption.getAttribute('data-min-persons'))) {
                                    addonsOption.classList.remove('has-error--persons');
                                } else {
                                    addonsOption.classList.add('has-error--persons');
                                }

                                if(daysToGivenDate(dateValue) >= parseInt(addonsOption.getAttribute('data-date-offset'))) {
                                    addonsOption.classList.remove('has-error--date');
                                } else {
                                    addonsOption.classList.add('has-error--date');
                                }

                                addonsOption.style.display = '';
                                hasValues = true;

                                const currentHeight = minHeight.offsetHeight;
                                if(minHeightValue < currentHeight) {
                                    minHeightValue = currentHeight;
                                }
                            } else {
                                addonsOption.style.display = 'none';
                                const input = addonsOption.querySelector('input');
                                if(input.classList.contains('nf-checked')) {
                                    addonsModel.set( 'value', '' );
                                    addonsModel.trigger( 'reRender', addonsModel );
                                }
                            }

                            label.onclick = (e) => {
                                if(!e.srcElement.classList.contains('c-listimage-card__content-button') && !label.classList.contains('is-triggerd-by-event')) {
                                    e.preventDefault();
                                }
                            }

                            button.onclick = (e) => {
                                label.classList.add('is-triggerd-by-event');
                                label.click();
                                label.classList.remove('is-triggerd-by-event');
                            };
                        });


                        if(!hasValues) {
                            addonsElm.style.display = 'none';
                        } else {
                            addonsElm.style.display = '';
                        }

                        addonsElm.style.setProperty('--pricing-height', `${minHeightValue}px`);
                    }

                    // extended step logic

                    const cl_date = findObjectModel(fields,KEYS.CL_DATE);

                    const cl_clothing_size = findObjectModel(fields,KEYS.CL_CLOTHING_SIZE);
                    const clothingSizeModel = findObjectModel(fields,KEYS.CLOTHING_SIZE);

                    const cl_ring_fields = findObjectModel(fields,KEYS.CL_RING_FIELDS);
                    const ringTypeModel = findObjectModel(fields,KEYS.RING_TYPE);
                    const ringColorModel = findObjectModel(fields,KEYS.RING_COLOR);

                    const cl_addons = findObjectModel(fields,KEYS.CL_ADDONS);

                    const cl_wedding_day = findObjectModel(fields,KEYS.CL_WEDDING_DAY);
                    const weddingDayModel = findObjectModel(fields,KEYS.WEDDING_DAY);

                    const cl_budget = findObjectModel(fields,KEYS.CL_BUDGET);
                    const budgetModel = findObjectModel(fields,KEYS.BUDGET);

                    const cl_contact_data = findObjectModel(fields,KEYS.CL_CONTACT_DATA);

                    const cl_style = findObjectModel(fields,KEYS.CL_STYLE);
                    const styleModel = findObjectModel(fields,KEYS.STYLE);

                    const cl_first_appointment = findObjectModel(fields,KEYS.CL_FIRST_APPOINTMENT);
                    const firstAppointmentModel = findObjectModel(fields,KEYS.FIRST_APPOINTMENT);

                    const cl_referral = findObjectModel(fields,KEYS.CL_REFERRAL);
                    const referralModel = findObjectModel(fields,KEYS.REFERRAL);

                    if((typeModel.get( 'value' ).length > 0 && typeModel.get( 'value' ))  && topicModel.get( 'value' ) !== '' && (storeModel.get( 'value' ).length > 0 && storeModel.get( 'value' )) && personModel.get( 'value' ) !== '' ) {
                        updateField(cl_date,'yes');
                    } else {
                        updateField(cl_date,'');
                    }

                    if(typeModel.get( 'value' ) && dateModel.get( 'value' ) && timeModel.get( 'value' ) && storeModel.get( 'value' )) {

                        const fieldIdAttribute = `[data-field-id="${typeModel.attributes.id}"]`;
                        const dataTypeAttribute = `li[data-type="${typeModel.get('value')}"]`;
                        const commonSelector = `${fieldIdAttribute} ${dataTypeAttribute}`;

                        if(document.querySelector(commonSelector)) {



                            const topicName = document.querySelector(commonSelector).dataset.topic.toLowerCase();
                            const typeName = document.querySelector(`${commonSelector} .c-listimage-card__content-title`).dataset.typeName.toLowerCase();

                            if(['brautkleid','standesamt','outlet'].includes(topicName)) {

                                // # Clothing size

                                if(['bridal fitting','summer sale fitting','standesamt','outlet fitting'].includes(typeName)) {
                                    updateField(cl_clothing_size,'yes');
                                } else if(['zweiter termin','mein kleid ist da','standesamt','outlet fitting'].includes(typeName)) {
                                    updateField(cl_clothing_size,'no');
                                }

                                // # Budget

                                if(['bridal fitting','summer sale fitting','standesamt','outlet fitting'].includes(typeName)) {
                                    updateField(cl_budget,'yes');
                                } else if(['zweiter termin','mein kleid ist da','standesamt','outlet fitting'].includes(typeName)) {
                                    updateField(cl_budget,'no');
                                }

                                // # Addons

                                if(['bridal fitting'].includes(typeName)) {
                                    updateField(cl_addons,'yes');
                                } else  {
                                    updateField(cl_addons,'no');
                                }

                                // # Wedding Day

                                if(['bridal fitting','summer sale fitting','standesamt','outlet fitting','zweiter termin'].includes(typeName)) {
                                    updateField(cl_wedding_day,'yes');
                                } else if(['mein kleid ist da','standesamt','outlet fitting'].includes(typeName)) {
                                    updateField(cl_wedding_day,'no');
                                }

                                // # Style

                                if(['bridal fitting','summer sale fitting','outlet fitting'].includes(typeName)) {
                                    updateField(cl_style,'yes');
                                } else {
                                    updateField(cl_style,'no');
                                }

                                // # First Appointment

                                if(['bridal fitting','summer sale fitting','standesamt','outlet fitting'].includes(typeName)) {
                                    updateField(cl_first_appointment,'yes');
                                } else {
                                    updateField(cl_first_appointment,'no');
                                }

                                // # Referral

                                if(['bridal fitting','summer sale fitting','standesamt','outlet fitting'].includes(typeName)) {
                                    updateField(cl_referral,'yes');
                                } else {
                                    updateField(cl_referral,'no');
                                }

                            } else if(['ringe'].includes(topicName)) {

                                // # Ring Fields

                                if(['trauringe'].includes(typeName)) {
                                    updateField(cl_ring_fields,'yes');
                                } else if(['ring pick-up'].includes(typeName)) {
                                    updateField(cl_ring_fields,'no');
                                }

                                // # Budget

                                if(['trauringe'].includes(typeName)) {
                                    updateField(cl_budget,'yes');
                                } else if(['ring pick-up'].includes(typeName)) {
                                    updateField(cl_budget,'no');
                                }

                                // # Wedding Day

                                if(['trauringe'].includes(typeName)) {
                                    updateField(cl_wedding_day,'yes');
                                } else if(['ring pick-up'].includes(typeName)) {
                                    updateField(cl_wedding_day,'no');
                                }

                                // # Referral

                                if(['trauringe'].includes(typeName)) {
                                    updateField(cl_referral,'yes');
                                } else {
                                    updateField(cl_referral,'no');
                                }

                            } else if(['brautjungfern'].includes(topicName)) {

                                // # Wedding Day

                                if(['brautjungfern'].includes(typeName)) {
                                    updateField(cl_wedding_day,'yes');
                                } else {
                                    updateField(cl_wedding_day,'no');
                                }

                            } else if(['accessoires'].includes(topicName)) {

                                // # Wedding Day

                                if(['accessoires termin'].includes(typeName)) {
                                    updateField(cl_wedding_day,'yes');
                                } else {
                                    updateField(cl_wedding_day,'no');
                                }

                            }


                            // # Contact Data

                            if(['brautkleid'].includes(topicName)) {

                                if(['bridal fitting', 'summer sale fitting'].includes(typeName)) {

                                    if(weddingDayModel.get( 'value' ) !== '' && clothingSizeModel.get( 'value' ) !== '' && budgetModel.get( 'value' ) !== '') {
                                        updateField(cl_contact_data,'yes');
                                    } else {
                                        updateField(cl_contact_data,'');
                                    }

                                } else if(['zweiter termin'].includes(typeName)) {

                                    if(weddingDayModel.get( 'value' ) !== '') {
                                        updateField(cl_contact_data,'yes');
                                    } else {
                                        updateField(cl_contact_data,'');
                                    }

                                } else if(['mein kleid ist da!'].includes(typeName)) {
                                    updateField(cl_contact_data,'yes');
                                }

                            } else if(['brautjungfern'].includes(topicName)) {

                                if(['brautjungfern'].includes(typeName)) {

                                    if(weddingDayModel.get( 'value' ) !== '' ) {
                                        updateField(cl_contact_data,'yes');
                                    } else {
                                        updateField(cl_contact_data,'');
                                    }

                                }

                            } else if(['outlet'].includes(topicName)) {

                                if(['outlet fitting'].includes(typeName)) {

                                    if(weddingDayModel.get( 'value' ) !== '' && clothingSizeModel.get( 'value' ) !== '' && budgetModel.get( 'value' ) !== '') {
                                        updateField(cl_contact_data,'yes');
                                    } else {
                                        updateField(cl_contact_data,'');
                                    }

                                }

                            } else if(['standesamt'].includes(topicName)) {

                                if(['standesamt'].includes(typeName)) {

                                    if(weddingDayModel.get( 'value' ) !== '' && clothingSizeModel.get( 'value' ) !== '' && budgetModel.get( 'value' ) !== '') {
                                        updateField(cl_contact_data,'yes');
                                    } else {
                                        updateField(cl_contact_data,'');
                                    }

                                }

                            } else if(['ringe'].includes(topicName)) {

                                if(['trauringe'].includes(typeName)) {

                                    if(weddingDayModel.get( 'value' ) !== '' && ringColorModel.get( 'value' ) !== '' && ringTypeModel.get( 'value' ) !== '') {
                                        updateField(cl_contact_data,'yes');
                                    } else {
                                        updateField(cl_contact_data,'');
                                    }

                                } else if(['ring pick-up'].includes(typeName)) {
                                    updateField(cl_contact_data,'yes');
                                }

                            } else if(['accessoires'].includes(topicName)) {

                                if(['accessoires termin'].includes(typeName)) {

                                    if(weddingDayModel.get( 'value' ) !== '' ) {
                                        updateField(cl_contact_data,'yes');
                                    } else {
                                        updateField(cl_contact_data,'');
                                    }

                                }

                            } else if(['abendmode'].includes(topicName)) {

                                if(['abendmode'].includes(typeName)) {
                                    updateField(cl_contact_data,'yes');
                                }

                            }

                        } else {

                            // # set defaults to hidden

                            updateField(cl_clothing_size,'');
                            updateField(cl_ring_fields,'');
                            updateField(cl_addons,'');
                            updateField(cl_contact_data,'');
                            updateField(cl_wedding_day,'');
                            updateField(cl_budget,'');
                        }

                    } else {

                        // # set defaults to hidden

                        updateField(cl_clothing_size,'');
                        updateField(cl_ring_fields,'');
                        updateField(cl_addons,'');
                        updateField(cl_contact_data,'');
                        updateField(cl_wedding_day,'');
                        updateField(cl_budget,'');
                    }
                }
            }

        },

        appointmentSetup: function (formModel) {
            if(formModel.attributes.is_bridallive_application) {

                document.getElementById(`nf-form-${formModel.attributes.id}-cont`).classList.add('is-application-form');


                setTimeout(() => {

                    new ShowMore('[data-read-more-container]:not([aria-expanded])', {
                        onMoreLess: (type, object) => {
                        },
                    });
                },500);

                const time = formModel.get('fields').findWhere({ key: KEYS.TIME });
                if (time) {

                    // # hide time field, as workaround, caused by multistep conditional bug

                    hideField(time,formModel);
                }

                this.listenTo(nfRadio.channel('fields'), 'change:modelValue', this.appointmentActions);
            }

        },

        appointmentDatepicker: function( dateObject, fieldModel ) {

            // # disable previous dates for datepicker

            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate());
            dateObject.set('minDate', yesterday);

            const fp = dateObject.element._flatpickr;

            if(fieldModel.attributes.field_key === KEYS.APPOINTMENT_DATE) {

                /*
                fp.set('disable',[
                    function (date) {
                        return (date.getDay() === 0);
                    }
                ]); */

            }

            let locale = fp.config.locale;
            locale.firstDayOfWeek = 1;
            fp.set('locale',locale);


        },

        appointmentActions: function (model) {
            const key = model.attributes.key;
            const formModel = nfRadio.channel( 'app' ).request( 'get:form', parseInt(model.attributes.formID));

            if (![KEYS.STORE, KEYS.TYPE, KEYS.APPOINTMENT_DATE, KEYS.TIME, KEYS.PERSONS].includes(key)) return;


            const cl_date = formModel.get('fields').findWhere({ key: KEYS.CL_DATE });
            const store = formModel.get('fields').findWhere({ key: KEYS.STORE });
            const type = formModel.get('fields').findWhere({ key: KEYS.TYPE });
            const date = formModel.get('fields').findWhere({ key: KEYS.APPOINTMENT_DATE });
            const time = formModel.get('fields').findWhere({ key: KEYS.TIME });
            const waitlist_from = formModel.get('fields').findWhere({ key: KEYS.WAITLIST_FROM });
            const waitlist_until = formModel.get('fields').findWhere({ key: KEYS.WAITLIST_UNTIL });

            switch (key) {

                case KEYS.TYPE:

                    // # reset selection value

                    hideField(date,formModel,true);

                    if (!model.get( 'value' )) {

                        // # set a random restricted date in the past to prevent selection of date during loading the real restrictions

                        date.attributes.restricted_dates = '1970-01-01';

                        // # hide time field, as workaround, caused by multistep conditional bug

                        hideField(time,formModel, true);

                    } else {

                        setTimeout(() => {
                            hideField(date,formModel,true);
                        },1)

                        let blockedDates = [];
                        rest.makeRequest('appointment/dates',{store:store.get('value')}).then(response => {

                            response.result.forEach(item => {
                                blockedDates.push(moment(item.endDateTime).format("YYYY-MM-DD"));
                            });

                            blockedDates.sort((a, b) => a - b);
                            date.attributes.restricted_dates = blockedDates.join(',');

                            if(cl_date.get('value') === 'yes') {
                                showField(date,formModel);
                            }

                        });
                    }

                    break;
                case KEYS.APPOINTMENT_DATE:

                    // # set default values to reset field if parent dependency changes

                    let defaultTimeValue = [];

                    time.attributes.desc_text = "";
                    time.attributes.value = "";

                    let defaultWaitListFromValue = [];
                    waitlist_from.attributes.value = "";

                    let defaultWaitListUntilValue = [];
                    waitlist_until.attributes.value = "";

                    if (!model.get( 'value' )) {

                        // # remove any options from time selection

                        time.attributes.options = defaultTimeValue;
                        waitlist_from.attributes.options = defaultWaitListFromValue;
                        waitlist_until.attributes.options = defaultWaitListUntilValue;

                        // # hide time field, as workaround, caused by multistep conditional bug

                        hideField(time,formModel);
                        hideField(waitlist_from,formModel);
                        hideField(waitlist_until,formModel);

                    } else {

                        setTimeout(() => {
                            hideField(time,formModel,true);
                        },1)

                        rest.makeRequest('appointment/timeslots', {store: store.get( 'value' ),type: type.get('value'),date: model.get('value')})
                            .then(response => {

                                let dynamicTimeValues;

                                if(response.length === 0) {

                                    time.attributes.desc_text = "An diesem Tag ist leider kein Termin frei.<br/> Du kannst dich aber auf unsere Warteliste setzen.";

                                    dynamicTimeValues = [
                                        {
                                            label: 'Ganztägig verfügbar',
                                            selected: false,
                                            value: `waitlist_allday`,
                                            li_classes: `is-full-width-option`
                                        },
                                        {
                                            label: 'zu bestimmten Zeiten',
                                            selected: false,
                                            value: `waitlist_special`,
                                            li_classes: `is-full-width-option`
                                        }
                                    ];

                                    let fromTimeSlots;
                                    if(moment(model.get( 'value' ),'DD.MM.YYYY').day() === 6) {
                                        fromTimeSlots = generateTimeSlots('09:00','19:00');
                                    } else {
                                        fromTimeSlots = generateTimeSlots('10:00','18:00');
                                    }

                                    waitlist_from.attributes.options = fromTimeSlots;

                                    hideField(waitlist_from,formModel);

                                    let untilTimeSlots;
                                    if(moment(model.get( 'value' ),'DD.MM.YYYY').day() === 6) {
                                        untilTimeSlots = generateTimeSlots('09:30','19:30');
                                    } else {
                                        untilTimeSlots = generateTimeSlots('10:30','18:30');
                                    }

                                    waitlist_until.attributes.options = untilTimeSlots;

                                    hideField(waitlist_until,formModel);


                                } else {

                                    dynamicTimeValues = response.map(item => {
                                        return {
                                            label: item.startDateTimeForView,
                                            selected: false,
                                            value: `${item.startDateTime}|${item.fittingRoomId}`
                                        };
                                    });
                                }



                                dynamicTimeValues.sort((a, b) => a.value - b.value);
                                time.attributes.options = dynamicTimeValues;

                                showField(time,formModel);
                            });

                        // # show time field, as workaround, caused by multistep conditional bug

                        showField(time,formModel);

                    }

                    break;

                default:

                    break;
            }

        },

    });


    jQuery( document ).ready( function( $ ) {
        // Instantiate our custom controller, defined above.
        new appointmentFormHandler();
    });

}, { once: true })

/**
 * Finds the first object in the given array that has a property with a matching key.
 *
 * @param {Array} objs - The array of objects to search through.
 * @param {string} key - The key to search for in the objects.
 * @returns {*} - The found object or undefined if no object with the matching key is found.
 */
function findObjectModel(objs, key) {
    return objs.find(obj => obj.attributes.key === key);
}

/**
 * Generates an array of time slots within a given start and end time.
 *
 * @param {string} startTime - The start time in HH:MM format.
 * @param {string} endTime - The end time in HH:MM format.
 * @returns {Array.<Object>} An array of time slots with formatted values and labels.
 */
function generateTimeSlots(startTime, endTime) {
    let timeslots = [{
        value: '',
        label: 'Bitte wählen',
        selected: true,
    }];

    let [startHour, startMinutes] = startTime.split(':').map(Number);
    let [endHour, endMinutes] = endTime.split(':').map(Number);
    let isFirst = true;

    for (let hour = startHour; hour <= endHour; hour++) {
        let minuteIntervals = [0, 30];

        // Adjust minute intervals for the first hour if needed
        if (hour === startHour) {
            minuteIntervals = startMinutes < 30 ? [startMinutes, 30] : [startMinutes];
        }

        for (let minutes of minuteIntervals) {
            if (hour === endHour && minutes >= endMinutes) break;

            let timeSlot = `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
            let formattedTimeSlot = `${hour.toString().padStart(2, '0')}-${minutes === 0 ? '00' : '30'}`;

            timeslots.push({ value: formattedTimeSlot, label: timeSlot, selected: false });
            isFirst = false;

            // Prevent generating a time slot beyond the end time
            if (hour === endHour && minutes + 30 >= endMinutes) break;
        }
    }

    return timeslots;
}